module.exports = __webpack_public_path__ + "img/scanning_grip.fe7bfb46.svg";